var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.5C0 8.26142 2.23858 10.5 5 10.5C7.76142 10.5 10 8.26142 10 5.5C10 2.73858 7.76142 0.5 5 0.5C2.23858 0.5 0 2.73858 0 5.5ZM0.666667 5.5C0.666667 3.10677 2.60677 1.16667 5 1.16667C6.14927 1.16667 7.25147 1.62321 8.06413 2.43587C8.87679 3.24853 9.33333 4.35073 9.33333 5.5C9.33333 7.89323 7.39323 9.83333 5 9.83333C2.60677 9.83333 0.666667 7.89323 0.666667 5.5Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5H2.33333C2.14924 5.5 2 5.33719 2 5.13636C2 4.93553 2.14924 4.77273 2.33333 4.77273H4.33333V1.86364C4.33333 1.66281 4.48257 1.5 4.66667 1.5C4.85076 1.5 5 1.66281 5 1.86364V5.5Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.bb3a93756f26604a94cb51f21f3cbde1.svg";
export { ForwardRef as ReactComponent };